import React from 'react';
import { Flex } from '@withjoy/joykit';
import { FilterPill } from './FilterPill';
import type { FilterFacet } from '../Filter.types';
import { useFilterChangeHandler } from '../useFilterChangeHandler';
import { noop } from '@shared/utils/noop';

type FilterOverflowRowProps = Readonly<{
  facets: FilterFacet[];
  pillHeight?: number;
}>;

/**
 * The full-width second row that reveals the facets hidden behind the "More" pill. Rendered at the
 * top level of the filter bar (a sibling of the primary row) so it spans the entire width rather
 * than being confined to the filter column that shares row one with the search bar.
 */
export const FilterOverflowRow = ({ facets, pillHeight }: FilterOverflowRowProps) => {
  const handleOnFilterChange = useFilterChangeHandler();

  return (
    <Flex
      width="100%"
      flexWrap="wrap"
      alignItems="center"
      gap={4}
    >
      {facets.map(facet => (
        <FilterPill
          key={facet.groupCode}
          interaction="popover"
          facet={facet}
          onFilterChange={handleOnFilterChange}
          onTriggerFilterDrawer={noop}
          pillHeight={pillHeight}
        />
      ))}
    </Flex>
  );
};
